import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';

interface Props extends RouteProps {
    component: any;
    contextProvider?: any;
}

const PrivateRoute = (props: Props) => {
    const { component: Component, contextProvider: ContextProvider, ...rest } = props;
    const { isAuthenticated } = useAuth();
    return (
        <Route
            {...rest}
            render={routeProps =>
                isAuthenticated ? (
                    <ContextProvider>
                        <Component {...routeProps} />
                    </ContextProvider>
                ) : (
                    <Redirect to="/" />
                )
            }
        />
    );
};

export default PrivateRoute;
